import svgData from "./svgData";
import { PathElement } from "../../svgHelpers";
import type { SVGProps, SVGElementProps } from "../../types";

const Close: SVGProps = (props: SVGElementProps) => (
  <>
    <PathElement {...props} path={svgData.path.d1} />
    <PathElement {...props} path={svgData.path.d2} />
  </>
);

export default Close;
